import React from 'react';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Image, { IImage } from 'tbk-components/src/components/Image';
import Button, { ILink } from 'tbk-components/src/components/Button';

export interface IContentTileEventProps extends IBaseElementProps {
	tileImage?: IImage;
	tileReadTime?: string;
	tileHeading?: string;
	tileLocation?: string;
	tileDate?: string;
	tileTags?: ILink[];
	tileDescription?: string;
	tileLink?: ILink;
	/**
	 * @noUI
	 */
	inverted?: boolean;
}

const ContentTileEvent: React.FC<IContentTileEventProps> = ({
	tileImage,
	tileReadTime,
	tileHeading,
	tileLocation,
	tileDate,
	tileTags,
	tileDescription,
	tileLink,
	inverted = false,
}) => (
	<div className="card rounded-5 border-0 p-3 p-md-5 container-fluid">
		<div className="row">
			<div className="col-12 col-sm-5 col-md-4 col-lg-12">
				{tileImage && (
					<div className="card-img-top">
						{tileLink?.href ? (
							<a
								className="text-inherit text-decoration-none"
								href={tileLink.href}
								target={tileLink.target}
							>
								<Image
									className="img-fluid rounded-5"
									{...tileImage}
								/>
							</a>
						) : (
							<Image
								className="img-fluid rounded-5"
								{...tileImage}
							/>
						)}
					</div>
				)}
			</div>
			<div className="col-12 col-sm-7 col-md-8 col-lg-12">
				<div className="card-body pt-5 pt-sm-0 pt-lg-5 pb-0 px-0">
					{tileReadTime && (
						<p className="card-text small mb-0">{tileReadTime}</p>
					)}
					{tileHeading && (
						<h4 className="card-title pe-md-3 ">
							{tileLink?.href ? (
								<a
									className="text-dark text-decoration-none"
									href={tileLink.href}
									target={tileLink.target}
								>
									{tileHeading}
								</a>
							) : (
								tileHeading
							)}
						</h4>
					)}

					{tileLocation && (
						<p className="card-text small mb-3">{tileLocation}</p>
					)}

					{tileDate && (
						<p className="card-text h6 mb-4">{tileDate}</p>
					)}

					{tileTags && tileTags.length > 0 && (
						<div className="card-tags mt-3 mb-1">
							{tileTags.map((tag, index) => (
								<Button
									className="card-tag-link btn btn-sm btn-light mb-2 me-2"
									key={index}
									{...tag}
								/>
							))}
						</div>
					)}

					{tileDescription && (
						<p className="card-text mb-4">{tileDescription}</p>
					)}

					{tileLink && (
						<div className="card-link">
							<Button
								size="sm"
								type={inverted ? 'secondary' : 'primary'}
								{...tileLink}
							/>
						</div>
					)}
				</div>
			</div>
		</div>
	</div>
);

export default ContentTileEvent;
